import { render, staticRenderFns } from "./DeleteIrDevice.vue?vue&type=template&id=04a57bd4"
import script from "./DeleteIrDevice.vue?vue&type=script&lang=js"
export * from "./DeleteIrDevice.vue?vue&type=script&lang=js"
import style0 from "./DeleteIrDevice.vue?vue&type=style&index=0&id=04a57bd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports